import React from 'react';

import { IDataset, IFolderNode } from '../../types/dataset';

import DatasetComponent from '../../components/dataset';
import { listS3Objects, makeBucketUrl } from '../../utils/s3';
import { isNil } from 'lodash-es';

interface Props {}

interface State {
  dataset?: IDataset;
  folderTree?: IFolderNode;
  folderRoot?: string;
}

const patchTree = (node: IFolderNode, newNode: IFolderNode): IFolderNode => {
  if (node.id === newNode.id) {
    return newNode;
  }

  const nodeOut: IFolderNode = {
    ...node,
    children: Array.isArray(node.children)
      ? node.children.map((child) => patchTree(child, newNode))
      : node.children,
  };

  return nodeOut;
};

class DatasetContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    fetch(`${process.env.PUBLIC_URL}/deployment/dataset.json`)
      .then((res) => res.json())
      .then((dataset: IDataset) => {
        // Fetch the dataset markdown content
        fetch(`${process.env.PUBLIC_URL}/deployment/${dataset.content}`)
          .then((res) => res.text())
          .then((content) =>
            this.setState({ dataset: { ...dataset, content } })
          );

        // Fetch the dataset folder tree
        const { region, bucket, prefix } = dataset;
        listS3Objects(region, bucket, prefix).then((folderTree) => {
          folderTree.name = '/';
          this.setState({ folderTree });
        });
      });
  }

  onNodeClick = (node: IFolderNode) => {
    const { dataset, folderTree } = this.state;

    if (isNil(dataset) || isNil(folderTree)) {
      return;
    }

    const { region, bucket } = dataset;

    if (node.type === 'folder') {
      if (isNil(node.children)) {
        this.setState({
          folderTree: patchTree(folderTree, { ...node, children: 'loading' }),
        });

        listS3Objects(region, bucket, node.path).then((folderNode) => {
          folderNode.id = node.id;
          this.setState({ folderTree: patchTree(folderTree, folderNode) });
        });
      }
    } else if (node.type === 'file') {
      const url = `${makeBucketUrl(bucket, region)}/${node.path}`;
      const el = document.createElement('a');
      el.href = url;
      el.download = node.name;
      el.click();
      el.remove();
    }
  };

  render() {
    const { dataset, folderTree } = this.state;
    return (
      <DatasetComponent
        dataset={dataset}
        folderTree={folderTree}
        onNodeClick={this.onNodeClick}
      />
    );
  }
}

export default DatasetContainer;
